import { PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects'
import apis from './apis'
import {
  areFulfillmentCenterTypeFiltersEqual,
  filterFulfillmentCentersByType,
  normalizeFulfillmentCenterTypeFilters,
} from './fulfillmentCenterFilters'
import { actions } from './state'
import { FulfillmentCenterTypeFilters, State } from './types'
import StockAddressingInBatchSaga from './stock-addressing-in-batch/StockAddressingInBatchSaga'
import StockAdjustmentInBatchSaga from './stock-adjustment-in-batch/StockAdjustmentInBatchSaga'
import StockListSaga from './stock-list/StockListSaga'
import StockManagementSaga from './stock-management/StockManagementSaga'
import StockMovementsSaga from './stock-movements/StockMovementsSaga'
import TaxCouponSaga from './tax-coupon/TaxCouponSaga'
import ReceivementSaga from './receivement/ReceivementSaga'
import FractionSaga from './fraction/FractionSaga'
import DanfeSaga from '../components/Danfe/danfeSagas'
import PendingReceivementsSaga from './pending-receivements/PendingReceivementsSaga'
import SupplierSaga from './supplier/SupplierSaga'
import ReceivementOverviewListSaga from './receivement-overview-list/ReceivementOverviewListSaga'
import BasicQuerySagas from './basic-queries/BasicQueriesSagas'
import DockManagementSagas from './dock-management/DockManagementSaga'
import LossSaga from './loss/LossSaga'
import EmailSettingsSaga from './email-settings/EmailSettingsSaga'
import RestockingSaga from './restocking/RestockingSaga'
import DivergenceDemandsSaga from './divergence-demands/DivergenceDemandsSaga'
import InventorySaga from './inventory/InventorySaga'
import ShedManagementSaga from './shed-management/ShedManagementSaga'
import SwapOrReturnSaga from './swap-or-return/SwapOrReturnSaga'
import PrintersManagementSaga from './settings/printers-management/PrintersManagementSaga'
import TransfersSaga from './transfers/TransfersSaga'

export function* getAvailableFulfillmentCenters(action: PayloadAction<FulfillmentCenterTypeFilters>) {
  try {
    const requestedFilters = normalizeFulfillmentCenterTypeFilters(action.payload)
    const status: State['app']['fulfillmentCentersStatus'] = yield select(
      (state: State) => state.app.fulfillmentCentersStatus,
    )
    const currentFilters: State['app']['fulfillmentCentersFilters'] = yield select(
      (state: State) => state.app.fulfillmentCentersFilters,
    )

    if (status === 'succeeded' && areFulfillmentCenterTypeFiltersEqual(currentFilters, requestedFilters)) {
      return
    }

    yield put(actions.setFulfillmentCentersStatus('loading'))

    const result = yield call(apis.getAvailableFulfillmentCenters)

    if (!result.isOk) {
      yield put(actions.setFulfillmentCentersStatus('failed'))
      toast.error(result.data?.data?.message || 'Falha ao carregar FCs disponíveis')
      return
    }

    const token: State['app']['token'] = yield select((state: State) => state.app.token)

    if (!token) {
      return
    }

    yield put(actions.setFulfillmentCenters(filterFulfillmentCentersByType(result.data, requestedFilters)))
    yield put(actions.setFulfillmentCentersFilters(requestedFilters))
  } catch (error: any) {
    yield put(actions.setFulfillmentCentersStatus('failed'))
    toast.error('Falha ao carregar FCs disponíveis!')
  }
}

export default function* () {
  yield all([
    takeLatest(actions.getAvailableFulfillmentCenters.type, getAvailableFulfillmentCenters),
    StockListSaga(),
    StockManagementSaga(),
    StockMovementsSaga(),
    StockAddressingInBatchSaga(),
    StockAdjustmentInBatchSaga(),
    TaxCouponSaga(),
    ReceivementSaga(),
    FractionSaga(),
    DanfeSaga(),
    PendingReceivementsSaga(),
    SupplierSaga(),
    ReceivementOverviewListSaga(),
    BasicQuerySagas(),
    DockManagementSagas(),
    LossSaga(),
    EmailSettingsSaga(),
    RestockingSaga(),
    DivergenceDemandsSaga(),
    InventorySaga(),
    ShedManagementSaga(),
    SwapOrReturnSaga(),
    PrintersManagementSaga(),
    TransfersSaga(),
  ])
}
